<template>
    <div class="about">
        <!--  轮播-->
        <div class="swiper">
            <el-row>

                <el-col :span="12" style="padding-right: 15rem">
                    <h3>聚焦客户需求 <br/>持续为客户创造价值</h3>
                    <h5>
                        成为中国一流的信息技术服务提供商
                    </h5>
                </el-col>
                <el-col :span="12">
                    <img src="../../../assets/about/about1.png" width="100%">
                </el-col>
            </el-row>
            <!-- Additional required wrapper -->
            <!--      <div class="swiper-wrapper">-->
            <!-- Slides -->
            <!--        <div class="swiper-slide" v-for="(item,index) in swiperimgData" :key="index">-->
            <!--          <img :src="require('../../../assets/'+item.url)" width="100%">-->
            <!--        </div>-->
            <!--      </div>-->
            <!-- If we need pagination -->
            <!--      <div class="swiper-pagination"></div>-->

            <!-- If we need navigation buttons -->
            <!--    <div class="swiper-button-prev"></div>-->
            <!--    <div class="swiper-button-next"></div>-->

            <!-- If we need scrollbar -->
            <!--    <div class="swiper-scrollbar"></div>-->
        </div>
        <!--关于我们-->
        <section>
            <div class="wrap" style="padding-bottom: 4rem;padding-top: 6rem">
                <div class="name">关于我们</div>
                <div style="display: flex; justify-content: center; align-items: center; flex-wrap: wrap; flex-direction: column">
                    <!--        <img :src="require('../../../assets/'+gywourl)" style="width: 100%; height: 36rem">-->
                    <div style="font-size: 2rem;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;
color: #333333;line-height: 3rem; width: 100%; margin-top: 7.6rem; width: 100%; margin: auto;">
                        <p style="text-indent: 2em; font-size: 16px; margin-bottom: 4rem">
                            福建纵横创建于2009年，是一家提供数字化服务、软件研发、企业管理咨询服务、企业互联网解决方案、大数据服务、人才派遣服务、员工福利、区块链技术输出等信息产业相关服务的企业。我们以为客户提供数字化相关一站式服务为宗旨。截止2022年公司整体软件及信息化研发板块，拥有员工70多人，其中信息化技术及软件研发人员50人，专业信息化咨询、实施、交付与服务人员20人，高级计算机人才占公司员工结构的100%。其旗下“万启人力” 外包人力服务板块拥有500多人，为客户提供智能化、园区运行管理及企业IT员工租赁派遣等人事外包服务工作。
                        </p>
                        <p style="text-indent: 2em;font-size: 16px; margin-bottom: 4rem">公司是国家级高新技术企业，并与国内多家研究机构和高校：国家工业信息安全发展研究中心(工业和信息化部电子第一研究所)、中科院海西研究院，厦门大学、福州大学、福建工程学院、福建阳光学院等建立“产学研” 合作体系。也是国内互联网企业“京东云”、“腾讯云” 在福建区域的总代理商，负责“京东云”、“腾讯云”在福建区域的 “业务中台”、“数据中台”、““智慧仓储”、“智慧园区”等解决方案的指定唯一服务商。同时，也是知名上市公司用友股份，金蝶软件的专业授权销售、开发、交付、服务伙伴。为客户提供用友NC\NCC、金蝶EAS\k3等序列产品的信息化咨询、销售与实施交付支持工作。</p>
                        <p style="text-indent: 2em;font-size: 16px;"> 公司始终坚持“用信息技术推动商业和社会进步”的使命、定位 “为企业、政府、院校及社会组织资源聚合提供“智慧化”信息化平台服务”、并立志成为“行业领先的企业&政府&院校（社会组织)信息化管理与增值服务提供商”。</p>
                    </div>

                </div>
                <div class="about2" style="position: relative;">
                    <div style="position: absolute; left: 50rem; top: 5.5rem">
                        <h3 style="font-size: 2.6rem;font-weight: 400; margin-bottom: 1.8rem">成为中国一流的信息技术服务提供商</h3>
                        <h5 style="font-size: 16px;  font-weight: 100; line-height:1.6">聚焦客户需求、提供实用、管用、好用的信息化解决方案和服务，持续<br/>为客户创造价值</h5>
                    </div>
                </div>
            </div>
        </section>
        <!--团队介绍-->
        <section class="about3">
            <div class="wrap">
                <div class="name">团队介绍</div>
                <div style="display: flex; justify-content: space-between; align-items: center;  text-align: center; margin-top: 10rem">
                    <div class="tdbox">
                        <img :src="require('../../../assets/about/jj.png')" style="width: 14rem"/>
                        <div  class="tdbox-top">
                            <div class="name">陈俊箭</div>
                            <div class="zw">联合创始人/研发总经理</div>
                            <dl>
                                <dd>软件架构师&nbsp;&nbsp;&nbsp;&nbsp;软件设计师</dd>
                                <dd>系统分析师</dd>
                            </dl>
                        </div>
                    </div>
                    <div class="tdbox">
                        <img :src="require('../../../assets/about/about44.png')" style="width: 14rem"/>
                        <div  class="tdbox-top">
                            <div class="name">龚丽娟</div>
                            <div class="zw">联合创始人/副总裁</div>
                            <dl>
                                <dd>财务及内控领域产品架构师</dd>
                                <dd>高级咨询规划师</dd>
                            </dl>
                        </div>
                    </div>
                    <div class="tdbox" >
                        <img :src="require('../../../assets/about/about47.png')"   style="transform: scale(1.1)  translateY(-9rem); width: 20rem"/>
                        <div style="margin-top: -9.4rem"  class="tdbox-top">
                            <div class="name" >林鹏</div>
                            <div class="zw">联合创始人/总裁</div>
                            <dl>
                                <dd>国际注册人力资源管理师</dd>
                                <dd>PMP项目管理国际认证顾问</dd>
                                <dd>高级咨询顾问&nbsp;&nbsp;&nbsp;&nbsp;IT咨询规划师</dd>
                            </dl>
                        </div>
                    </div>
                    <div class="tdbox">
                        <img :src="require('../../../assets/about/about45.png')" style="width: 14rem"/>
                        <div  class="tdbox-top">
                            <div class="name">冯振光</div>
                            <div class="zw">联合创始人/副总裁</div>
                            <dl>
                                <dd>PMP项目管理国际认证顾问</dd>
                                <dd>产品架构师</dd>
                                <dd>高级咨询顾问</dd>
                            </dl>
                        </div>

                    </div>

                    <div class="tdbox">
                        <img :src="require('../../../assets/about/td-csh.png')" style="width: 14rem"/>
                        <div class="tdbox-top">
                            <div class="name">施秋济</div>
                            <div class="zw">联合创始人/项目总经理</div>
                            <dl>
                                <dd>供应链及创新产品架构师</dd>
                                <dd>高级咨询顾问</dd>
                                <dd>IT咨询规划师</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--发展历程-->
      <section>
        <div class="wrap">
          <div class="name">发展历程</div>
          <div class="timeline" style="position: relative;">
            <!-- 循环渲染每个时间轴项 -->
            <div
                v-for="(item, index) in timelineData"
                :key="index"
                class="timeline-item"
                style="position: relative; width: 100%; margin-bottom: 3rem; display: flex; align-items: center;"
            >
              <!-- 左侧内容（偶数项） -->
              <div
                  v-if="index % 2 === 0"
                  class="timeline-content left"
                  style="width: calc(50% - 30px); text-align: right; display: flex; justify-content: flex-end;"
              >
                <div style="display: flex; align-items: flex-start; gap: 1rem;width: 46rem">
                  <div class="timeline-desc" style="line-height: 2.5rem;font-size: 1.75rem;min-height: 5rem;">{{ item.content }}</div>
                  <div style="line-height: 2.5rem;font-size: 1.75rem;min-height: 5rem;">——</div>
                  <div class="timeline-year" style="line-height:2.5rem;font-size: 2.5rem; font-weight: bold; color: #ff0b41;min-height: 5rem">{{ item.year }}</div>
                </div>
              </div>

              <!-- 中间：线轴图标（固定在中间线） -->
              <img
                  src="../../../assets/about/xz.png"
                  style="height: 7rem; position: absolute; left: 50%;top:15%;transform: translateX(-50%); z-index: 10;"
              >

              <!-- 右侧内容（奇数项） -->
              <div
                  v-if="index % 2 === 1"
                  class="timeline-content right"
                  style="width: calc(50% - 30px); margin-left: auto; text-align: left; display: flex;"
              >
                <div style="display: flex; align-items: flex-start; gap: 1rem;width: 46rem">
                  <div class="timeline-year" style="line-height:2.5rem;font-size: 2.5rem; font-weight: bold; color: #ff0b41;min-height: 5rem;">{{ item.year }}</div>
                  <div style="line-height: 2.5rem;font-size: 1.75rem;min-height: 5rem;">——</div>
                  <div class="timeline-desc" style="line-height: 2.5rem;font-size: 1.75rem;min-height: 5rem">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--软件著作权-->
      <section class="about5">
        <div class="wrap">
          <div class="name">行业认可</div>
          <el-tabs
              v-model="activeTab"
              class="recognition-tabs"
          >
            <el-tab-pane label="企业相关" name="enterprise"></el-tab-pane>
            <el-tab-pane label="产品认证" name="product"></el-tab-pane>
            <el-tab-pane label="软件著作" name="copyright"></el-tab-pane>
          </el-tabs>
          <!-- 轮播容器 -->
          <div class="swiper2" style="
            position: relative;
            display: block;
            overflow: hidden;
            padding: 5rem 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
        ">
            <!-- 轮播包裹器 -->
            <div class="swiper-wrapper" style="
                display: flex;
                transition-timing-function: linear;
                width: max-content;
                align-items: center;
            ">
              <div
                  class="programmelist swiper-slide"
                  style="
                        flex-shrink: 0;
                        width: auto;
                        padding: 0 0.5rem;
                        transition: transform 0.5s ease;
                    "
                  v-for="(item, index) in currentImages"
                  :key="index"
              >
                <div class="list-box" style="width: 30rem; max-width: 100%;justify-content: center;" @click="openViewer([item.src])">
                  <el-image
                      :src="item.src"
                      style="width: 30rem; max-width: 100%;"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        <el-image-viewer
                v-if="viewerVisible"
                :url-list="viewerUrlList"
                @close="closeViewer"
                :initial-index="0"
        />

        <!--新闻与活动-->
        <section  style="background: #fff">
            <div class="wrap">
                <div class="name">新闻与活动</div>
                <div class="boxwrap">
                    <div class="box"  @click="getOneNews()">
                        <img :src=enentFirst.firstPhoto style="width: 79rem;height: 250px;border-radius: 3px;margin-left: 1px">
                        <div class="boxname">
                            <i>{{ enentFirst.category }}</i>
                            <span>{{ enentFirst.title }}</span>
                        </div>
                    </div>
                    <div class="box" v-for="item in eventList" :key="item.id" @click="getOneNews(item.id)">
                        <img :src=item.firstPhoto style="width: 38rem;height: 250px;border-radius: 3px;margin-left: 1px">
                        <div class="boxname">
                            <i>{{ item.category }}</i>
                            <span>{{ item.title }}</span>
                        </div>
                    </div>
                    <!--                      <el-pagination-->
                    <!--                              background-->
                    <!--                              @current-change="handleCurrentChange"-->
                    <!--                              :current-page.sync="pageNum"-->
                    <!--                              :page-size="pageSize"-->
                    <!--                              layout="prev, pager, next"-->
                    <!--                              :total=total-->
                    <!--                              style="text-align: center; margin-top: 50px;margin-left: 45%">-->
                    <!--                      </el-pagination>-->
                </div>
            </div>
        </section>
    <!--联系我们-->
    <section n class="about7" style="padding-bottom: 20rem">
      <div class="wrap">
        <div class="name">联系我们</div>
        <div class="aboutme">
         <div class="mebox">
           <div class="me-name">{{ companys.name }}</div>
           <div class="list" style="width: 451px">
             <span>地址：{{ companys.address }}</span>
           </div>
           <div class="list">
             <i>电话：</i>
             <span>{{ companys.phone }}</span>
           </div>
           <div class="list">
             <i>邮箱：</i>
             <span>{{ companys.businessEmail }}</span>
           </div>
           <div class="ewm">
             <img :src=companys.wechatImg style="width: 12.8rem">
             <i>关注我，了解更多信息</i>
           </div>
         </div>
          <div class="map">
              <div id="dituContent" style="width: 60rem;height: 38.5rem;display: block;overflow: hidden"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper, {Autoplay, Navigation} from "swiper";
import newService from "@/api/newService";
import { ElImageViewer } from "element-plus"; // 导入Element Plus的预览组件
// 导入组件

export default {
  name: "aboutIndex",
    created() {
    },
    data(){
    return {
      activeTab: 'enterprise',
      recognitionImages: {
        enterprise: [
          { src: require('../../../assets/about/about33.png') },
          { src: require('../../../assets/about/about34.png') },
          { src: require('../../../assets/about/about35.png') },
          { src: require('../../../assets/about/about36.png') },
          { src: require('../../../assets/about/about37.png') },
          { src: require('../../../assets/about/about38.png') },
          { src: require('../../../assets/about/ryzz-17.png') },
          { src: require('../../../assets/about/ryzz-16.png') },
          { src: require('../../../assets/about/ryzz-15.png') },
          { src: require('../../../assets/about/ryzz-22.png') },
          { src: require('../../../assets/about/ry-ryzz-18.png') },
          { src: require('../../../assets/about/ry-ryzz-10.png') },
          { src: require('../../../assets/about/ry-rz-01.png') },
          { src: require('../../../assets/about/isozltxzs.png') },
        ],
        product: [
          { src: require('../../../assets/about/ryzz-18.png') },
          { src: require('../../../assets/about/ryzz-19.png') },
          { src: require('../../../assets/about/ryzz-20.png') },
          { src: require('../../../assets/about/ryzz-21.png') },
          { src: require('../../../assets/about/aboutql1.png') },
          { src: require('../../../assets/about/aboutql2.png') },
          { src: require('../../../assets/about/aboutql3.png') },
          { src: require('../../../assets/about/aboutql4.png') },
          { src: require('../../../assets/about/aboutql5.png') },
        ],
        copyright: [
          { src: require('../../../assets/about/ruanzhu/rz1.png') },
          { src: require('../../../assets/about/ruanzhu/rz2.png') },
          { src: require('../../../assets/about/ruanzhu/rz3.png') },
          { src: require('../../../assets/about/ruanzhu/rz4.png') },
          { src: require('../../../assets/about/ruanzhu/rz5.png') },
          { src: require('../../../assets/about/ruanzhu/rz6.png') },
          { src: require('../../../assets/about/ruanzhu/rz7.png') },
          { src: require('../../../assets/about/ruanzhu/rz8.png') },
          { src: require('../../../assets/about/ruanzhu/rz9.png') },
          { src: require('../../../assets/about/ruanzhu/rz10.png') },
          { src: require('../../../assets/about/ruanzhu/rz11.png') },
          { src: require('../../../assets/about/ruanzhu/rz12.png') },
          { src: require('../../../assets/about/ruanzhu/rz13.png') },
          { src: require('../../../assets/about/ruanzhu/rz14.png') },
          { src: require('../../../assets/about/ruanzhu/rz15.png') },
          { src: require('../../../assets/about/ruanzhu/rz16.png') },
        ]
      },
      timelineData: [
        { year: '未来', content: '新机遇，新挑战。不忘初心，与客户携手并进' },
        { year: '2024', content: '通过：达梦数据产品兼容适配认证、中科金仓数据兼容适配认证' },
        { year: '2023', content: '通过：高新技术企业认证、麒麟系统认证、统信系统适配认证、软件企业及软件产品认证' },
        { year: '2022', content: '做客户的优秀伙伴，成功登记4项国家软件著作权' },
        { year: '2021', content: '登记7项国家软件著作权，获AAA级信用企业 7项证书' },
        { year: '2020', content: '持续优化研发技术。成功登记5项国家软件著作权' },
        { year: '2010~2019', content: '纵横云创砥砺前行，在研发的道路上不断开拓创新' },
        { year: '2009', content: '福建纵横云创科技有限公司成立' },
      ],
        viewerVisible: false, // 预览窗口显示状态
        viewerUrlList: [], // 预览图片列表
        swiper2Instance: null, // 保存轮播实例
        ak: "I7ioGmQbypWKuWMNv5fLPKU4mt3gzhrz", // 正式线上项目，务必替换成自己的key
        BMap: null, // 百度地图对象
        map: null, // 地图实例
        url:[],
        showViewer: false, // 显示查看器
        isBackground: true,
        enentFirst:{},
        companys: [], // 接口返回的公司数据（含经纬度）
        aboutOne:{},
        pageNum:1,
        pageSize:5,
        total:0,
        eventList:[]
    }
  },
    components:{
        ElImageViewer
    },
  mounted() {
      this.initMap(); // 初始化地图（优先加载）
      this.getNewsAndEvents()
    // 轮播
    this.swiper2Instance = new Swiper(".swiper2", {
      speed: 4000,
      slidesPerView: "auto",
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        // 新增：确保自动播放不会在最后一张停止
        reverseDirection: false
      },
      modules: [Navigation, Autoplay],
    });
  },
  beforeUnmount() {
      // 销毁轮播实例
      if (this.swiper2Instance) {
          this.swiper2Instance.destroy();
      }
  },
  computed: {
    currentImages() {
      return this.recognitionImages[this.activeTab];
    }
  },
  methods:{
      // 打开预览窗口
      openViewer(urlList) {
        console.log(urlList);
          this.viewerUrlList = urlList; // 传入当前图片列表
          this.viewerVisible = true; // 显示预览窗口
      },
      // 关闭预览窗口
      closeViewer() {
          this.viewerVisible = false;
          this.viewerUrlList = [];
      },
      getAboutOne(){
          newService.getAboutOne().then((res)=>{
              this.aboutOne=res
          })
      },
      // 核心：初始化地图（修改重点）
      initMap() {
          const _this = this;
          // 1. 先获取公司位置数据（无需获取当前位置，直接用接口数据）
          newService.getTopCompany().then((res) => {
              _this.companys = res;
              // 校验接口返回的经纬度是否存在（避免空值报错）
              if (!res || !res.longitude || !res.latitude) {
                  console.error("接口未返回有效经纬度数据");
                  return;
              }
              // 2. 加载百度地图SDK（用Promise确保加载完成）
              _this.loadBMapSDK().then((BMap) => {
                  _this.BMap = BMap;
                  _this.createMap(); // 创建地图（核心逻辑）
                  _this.disableMapMove(); // 禁止地图移动（新增：满足“中心点不允许移动”需求）
              }).catch(error => {
                  console.error('百度地图加载失败:', error);
              });
          }).catch(err => {
              console.error("获取公司位置失败:", err);
          });
      },
      // 加载百度地图SDK（单独封装，复用性更高）
      loadBMapSDK() {
          return new Promise((resolve, reject) => {
              // 若已加载过，直接返回
              if (window.BMap) {
                  resolve(window.BMap);
                  return;
              }
              // 全局回调函数：SDK加载完成后触发
              window.initBMapCallback = function() {
                  resolve(window.BMap);
                  delete window.initBMapCallback; // 清理全局变量，避免污染
              };
              // 创建script标签引入SDK
              const script = document.createElement("script");
              script.type = "text/javascript";
              script.src = `https://api.map.baidu.com/api?v=3.0&ak=${this.ak}&callback=initBMapCallback`;
              script.onerror = () => reject(new Error("地图SDK加载超时或AK无效"));
              document.head.appendChild(script);
          });
      },
      // 创建地图（修改重点：仅渲染指定位置，修复图标创建、作用域问题）
      createMap() {
          const _this = this;
          // 1. 获取接口返回的经纬度（原数据是 longitude/latitude，注意顺序：百度地图是“经度lng在前，纬度lat在后”）
          const originalLng = _this.companys.longitude; // 接口返回的经度
          const originalLat = _this.companys.latitude; // 接口返回的纬度
          // 2. 创建原始坐标点（假设接口返回的是WGS84坐标系，需转为百度BD09坐标系）
          const originalPoint = new _this.BMap.Point(originalLng, originalLat);
          // 3. 坐标转换：WGS84 → BD09（确保地图定位准确）
          const convertor = new _this.BMap.Convertor();
          convertor.translate([originalPoint], 1, 5, function(data) {
              if (data.status !== 0) {
                  console.error("坐标转换失败，使用原始坐标");
                  return;
              }
              // 转换后的百度坐标
              const bdPoint = data.points[0];
              // 4. 初始化地图（绑定容器、设置中心点和缩放级别）
              const map = new _this.BMap.Map("dituContent");
              map.centerAndZoom(bdPoint, 14); // 缩放级别14（可根据需求调整，越大越详细）
              _this.map = map; // 保存地图实例到全局

              // 5. 创建并添加Marker（标记点，修复原图标创建错误）
              // 百度地图原生图标创建方式：new BMap.Icon()
              const markerIcon = new _this.BMap.Icon(
                  "http://map.baidu.com/image/us_mk_icon.png", // 图标URL（百度默认图标）
                  new _this.BMap.Size(23, 25), // 图标尺寸
                  {
                      imageOffset: new _this.BMap.Size(-46, -21), // 图标偏移（按原需求保留）
                      infoWindowOffset: new _this.BMap.Size(12 + 5, 1), // 信息窗偏移
                      offset: new _this.BMap.Size(9, 25) // 图标锚点偏移
                  }
              );
              // 创建Marker并添加到地图
              const marker = new _this.BMap.Marker(bdPoint, { icon: markerIcon });
              map.addOverlay(marker);

              // （可选）添加信息窗：点击Marker显示内容
              const infoWindow = new _this.BMap.InfoWindow(`<div>公司位置</div>`);
              marker.addEventListener("click", function() {
                  this.openInfoWindow(infoWindow);
              });
          });
      },
      // 禁止地图移动（新增：满足“中心点不允许移动”需求）
      disableMapMove() {
          const map = this.map;
          if (!map) return;
          // 禁用所有导致地图移动/缩放的交互：拖拽、滚轮缩放、双击缩放、键盘控制
          map.disableDragging(); // 禁止拖拽
          map.disableScrollWheelZoom(); // 禁止滚轮缩放
          map.disableDoubleClickZoom(); // 禁止双击缩放
          map.disableKeyboard(); // 禁止键盘控制
          // （可选）隐藏地图控件（避免用户通过控件操作地图）
          map.clearOverlays(); // 清除默认控件（如缩放按钮）
      },
      getmapAddress(){
          newService.getTopCompany().then((res)=>{
              this.companys=res
              const company = res;
              this.map = this.BMap.Map("map", {enableMapClick:false})  //新建地图实例，enableMapClick:false ：禁用地图默认点击弹框
              this.map.enableScrollWheelZoom(true);
              const x = company.longitude;
              const y = company.latitude;
              const mapPoint = parseInt(company.mapPoint);
              const point = this.BMap.Point(x, y);
              this.map.centerAndZoom(point,mapPoint)
              var ssr = this.BMap.Marker(point);
              this.map.addOverlay(ssr);
          })

      },
      getNewsAndEvents(){
          var obj={
              pageNum: this.pageNum,
              pageSize: this.pageSize
          }
          newService.getNewsAndEvents(obj).then((res)=>{
              this.eventList=res.rows
              this.enentFirst=this.eventList[0]
              this.eventList.shift()
              this.total=res.total
          })
      },
      prePage(){
          if (this.pageNum>1){
              this.pageNum=this.pageNum-1;
              this.getNewsAndEvents()
          }
          if (this.pageNum<=1){
             return;
          }
      },
      nextPage(){
          var count = this.pageNum*this.pageSize
          if (this.total<=count){
              return;
          }
          this.pageNum=this.pageNum+1;
          this.getNewsAndEvents();
      },
      getOneNews(){

      },
      handleCurrentChange(val) {
          this.pageNum=val;//当前页
          this.getNewsAndEvents()
      },
  }

}
</script>

<style lang="scss" scoped>
::v-deep .recognition-tabs {
  .el-tabs__nav {
    justify-content: center; // 确保标签在一行居中
    width: 100%; // 让导航栏占满宽度，确保居中效果
  }

  .el-tabs__item {
    text-align: center;
    font-size: 2.3rem;
    padding: 3rem 2.5rem;
    margin: 0 15rem;
    border-radius: 0; // 移除圆角，下划线效果更协调
    transition: all 0.3s ease;

    // 悬浮时字体变红
    &:hover {
      color: #ff0b41;
    }
    // 移除原有选中状态的背景色
    &.is-active {
      color: #ff0b41; // 选中时文字变红
      background-color: transparent;
    }
  }

  // 显示并设置选中下划线为红色
  .el-tabs__active-bar {
    display: block; // 显示下划线
    background-color: #ff0b41; // 下划线红色
    height: 3px; // 下划线高度
    width: 60%; // 下划线宽度（可根据需要调整）
  }
}
.el-pagination {
  ::v-deep .btn-prev,
  ::v-deep .btn-next {
    background-color: transparent;
  }
  ::v-deep .el-icon-arrow-left:before,
  ::v-deep .el-icon-arrow-right:before{
    color: #afaaaa;
  }
}

::v-deep .el-pagination.is-background .el-pager li{
  background-color: transparent;
  color: #afaaaa;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #FFEDEF;
  color: #FF0B41;
}

.swiper{
  width: 100%;
  background: url('../../../assets/about/about1bg.png') no-repeat; background-size: 100% 100%;
  .el-row{
    width: 120rem;
    min-width: 120rem;
    padding: 12rem 0 10rem;
    margin: auto;
    text-align: left;
    h3{

      margin-top: 10rem;
      font-size: 5rem;
      margin-bottom: 2rem;
    }
    h5{
      font-size: 2rem;
      font-weight: 400;
      color: #444955;
      line-height: 40px;
    }
  }
}
.about{
  padding-top: 0rem;
}

.wrap{
  width: 120rem;
  min-width: 120rem;
  padding: 10rem 0;
  margin: auto;
  display: block;
  overflow: hidden;
  .name{
    font-size: 4rem;
    color: #000;
    text-align: center;
    margin-bottom: 7rem;
  }
  .imglist{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    img{
      width: 41.6rem;
    }
  }
  .boxwrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .box{
      position: relative;
      display: block;
      overflow: hidden;
      cursor: pointer;
      margin-bottom: 2.2rem;
      transition:all  0.5s ease-in;
      .boxname{
        position: absolute;
        bottom: 0;
        width: 90%;
        left: 10%;
        display: flex;
        flex-direction: column;
        color: #fff;
        i{
          font-style: normal;
          font-size:1.8rem ;
          font-weight: 300;
        }
        span{
          font-size: 2.8rem;
          margin: 1rem 0 2rem;
        }
      }
      &:hover {
        span{
          margin: 1rem 0 4rem;
        }
        img{
          transform: scale(1.1);
        }
      }
    }
  }
  .aboutme{
    display: flex;
    justify-content: space-between;
    justify-items: center;
    .mebox{
      margin-right: 4rem;
      .me-name{
        font-size: 3rem;
        font-weight: 500;
        color: #333;
        letter-spacing: .2rem;
        margin-bottom: 4rem;
      }
      .list{
        display: flex;
        font-size: 2.4rem;
        line-height: 2;
        i{
          font-style: normal;
          margin-right: .5rem;
        }
      }
      .ewm{
        display: flex;
        align-items: center;
        margin-top: 2rem;
        i{
          font-style: normal;
        }
      }
    }
  }
  .lclist{
    display: flex;
    flex-wrap: wrap;
    .button{
      display: block;margin:2rem auto;
      width: 14rem;
      height: 3.6rem;
      line-height: 3.6rem;
      text-align: center;
      border-radius: .2rem;
      border: .1rem solid #E5E5E5;
      font-size: 2rem;
      color: #999999;
      font-weight: 400;
      cursor: pointer;
      &:hover{
        background: #eee;
      }
    }
    .lclist-box{
      width: 100%;
      display: flex;
      padding-bottom: 1rem;
      justify-content: space-between;
      position: relative;
      .year{
        font-size: 4rem;
padding-left: 3rem;
        position: relative;
        z-index: 1;
        &::after{
          content: '';
          position: absolute;
          left: 0;
          top: 2.4rem;
          width: 2rem;
          height: .2rem;
          background: #999;
        }
        &:before{
          content: none;
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          //border-left: 5px solid #999;
          border-style: dotted dotted dotted dotted;
          border-color: #D8D8D8;
        }
      }
      .year-box{
        background: #fff;
        display: flex;
        width: 111.5rem;
        margin-top: 6rem;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 3rem;
        .year-link{;
          padding: 2rem 2rem 2rem 3rem;
          a{
            display: block;
            text-decoration: none;
            color: #444955;
            line-height: 2;
            font-size: 2rem;
            &:hover{
              text-decoration: underline;
            }
          }
        }
        img{
          padding: 2rem;
        }
      }
      .xuline{
        position: absolute;
        left: 0;
        top: 2.4rem;
        width: 1rem;
        height: 100%;
        i{
          font-style: normal;
          left: 0;
          width: 1rem;
          height: .2rem;
          background:#D8D8D8 ;
          position: absolute;
          &:nth-child(1){
            top: 7.7%;
          }
          &:nth-child(2){
            top: 15.4%;
          }
          &:nth-child(3){
            top: 23.1%;
          }
          &:nth-child(4){
            top: 30.8%;
          }
          &:nth-child(5){
            top: 38.5%;
          }
          &:nth-child(6){
            top: 46.2%;
          }
          &:nth-child(7){
            top: 53.9%;
          }
          &:nth-child(8){
            top: 61.6%;
          }
          &:nth-child(9){
            top: 69.3%;
          }
          &:nth-child(10){
            top: 77%;
          }
          &:nth-child(11){
            top: 84.7%;
          }
          &:nth-child(12){
            top: 93.4%;
          }
        }
      }
    }
  }
  .tdbox{ width:22rem;
    margin-top: 7rem;
    .tdbox-top{
      height: 17rem;
    }
    .name{font-size: 3rem;
      font-family: PingFangSC-Medium, PingFang SC;
      margin-top: 4.6rem;
      margin-bottom: 1rem;
      font-weight: 500;
      color: #000000;
      line-height: 5rem;}
    .zw{font-size: 1.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 1.8rem;}
    dl{
      margin-top: 2.2rem;
      dd{
        font-style: normal;
        font-size: 1.2rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #444955;
        line-height: 0.8rem;
        margin-bottom: 1rem;
      }
    }

  }
  .licheng{
    position: absolute;
    display: inline-block;
    text-align: center;
    .year{
      font-size: 3.2rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 3.2rem;
      padding: 1.5rem 0;
      span{
        font-size: 2.4rem;
      }
    }
    .text{
      font-size: 2rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #444955;
      line-height: 3rem;
    }
  }
  .list-box{
    width: 124rem;
    margin:0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
}
.about2{width: 100%; height: 24rem; background: url('../../../assets/about/about2bg.png') no-repeat; background-size: cover; margin-top: 6rem}
.about3{
  background: url('../../../assets/about/about3bg.png') no-repeat;background-size: cover;
}
.about5{
  background: url('../../../assets/about/about5bg.png') no-repeat;background-size: cover;
}
.about7{
  background: url('../../../assets/about/about7bg.png') no-repeat;background-size: cover;
}

.anchorBL {
  display: none;
}
.clockinopation .el-dialog__body {
  padding: 20px;
  background: #f8f8f8;
}

.clockinopation .el-tabs__content {
  height: calc(100% - 60px);
  overflow-y: auto;
}

.clockinopation ::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

/*滚动条的轨道*/
.clockinopation ::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.clockinopation ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.clockinopation ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.clockinopation ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.clockinopation ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}

.salsaytabs {
  .el-tabs__nav-wrap {
    background: #fff;
    padding: 0 15px;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
  }

  .el-card__body {
    padding: 0;

    .clearfix {
      line-height: 40px;
      border-bottom: 1px solid #e4e7ed;
      padding: 0 15px;
      font-weight: bold;
    }

    .cardbox {
      padding: 15px;
      h4 {
        text-align: center;
        line-height: 26px;
        font-size: 20px;
      }
      .el-row.applyrow {
        width: 90%;
        margin: 10px auto;
        border-left: 1px solid #e4e7ed;
        border-top: 1px solid #e4e7ed;
        .el-col {
          padding: 0 15px;
          border-right: 1px solid #e4e7ed;
          border-bottom: 1px solid #e4e7ed;
          text-align: center;
          &.gray {
            background: #efefef;
          }
        }
      }
    }
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mt10 {
    margin-top: 10px;
  }
  .success {
    .el-timeline-item__tail {
      border-color: #67c23a;
    }
  }
}
.edith4 {
  padding-left: 15px;
  position: relative;
  &::after {
    position: absolute;
    width: 4px;
    height: 14px;
    background: var(--el-color-primary);
    left: 3px;
    top: 50%;
    transform: translateY(-50%);
    content: "";
    border-radius: 3px;
  }
}
</style>
